import { UploadCourseRequestsPanel } from "./upload-course-requests-panel";

interface WizardStepCourseRequestsProps {
  scheduleId: string;
  /**
   * Called when the user either uploads successfully OR skips. The wizard
   * treats both as "advance to step 3" because requests are optional preflight.
   */
  onContinue: () => void;
}

/**
 * Step 2 of the New Schedule wizard. Wraps {@link UploadCourseRequestsPanel}
 * inside the wizard's centered-card layout with a brief explainer and a
 * documentation of the expected CSV header.
 */
export function WizardStepCourseRequests({
  scheduleId,
  onContinue,
}: WizardStepCourseRequestsProps) {
  return (
    <div
      data-testid="wizard-step-course-requests"
      className="bg-surface border border-border-subtle rounded-lg p-6 animate-fade-in"
    >
      <h2 className="text-[17px] font-semibold text-white mb-1">
        Upload course requests
      </h2>
      <p className="text-[13px] text-text-muted mb-4">
        Upload the student course-request export from DASL. We&apos;ll match
        each request against the calendar&apos;s Course IDs.
      </p>

      <div className="mb-5 bg-page border border-border-subtle rounded-md px-3.5 py-3 text-[13px] text-text-soft">
        <div className="text-text-muted text-xs uppercase tracking-wide mb-1.5">
          CSV format
        </div>
        <div>
          Header row required. Columns:{" "}
          <code className="px-1 py-0.5 rounded bg-surface-2 text-white text-xs">
            StudentIdentifier
          </code>
          ,{" "}
          <code className="px-1 py-0.5 rounded bg-surface-2 text-white text-xs">
            CourseId
          </code>
          , and optional{" "}
          <code className="px-1 py-0.5 rounded bg-surface-2 text-white text-xs">
            Priority
          </code>{" "}
          (Required, High, Normal, or Low). The SIS export names{" "}
          <code className="px-1 py-0.5 rounded bg-surface-2 text-white text-xs">
            StudentNumber
          </code>{" "}
          and{" "}
          <code className="px-1 py-0.5 rounded bg-surface-2 text-white text-xs">
            CourseCode
          </code>{" "}
          are accepted too; any extra columns are ignored.
        </div>
      </div>

      <UploadCourseRequestsPanel
        scheduleId={scheduleId}
        onSuccess={onContinue}
        successActionLabel="Review"
        onSkip={onContinue}
      />
    </div>
  );
}
